<template>
  <Teleport :to="port">
    <div class="toast-list-container" :class="[position,{'is-mobile': isMobile}]">
      <transition-group name="toast" appear>
        <Toast
          v-for="toast in toastList"
          :key="toast.key"
          :toast="toast"
          :position="position"
          :isMobile="isMobile"
          @close="removeToast(toast.key)"
        >
          <slot v-if="!!slots.default" />
        </Toast>
      </transition-group>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, useSlots } from 'vue';
import Toast from './BaseToast.vue';
import { useCustomEvent } from '@/composables';
import type { IToast } from '@/types/components';

withDefaults(defineProps<IToastGroup>(), {
  isMobile: false,
  position: 'top-right',
  port: 'body',
});
const { catchEvent } = useCustomEvent();
export interface IToastGroup {
  isMobile?: boolean;
  position?: 'top-left' | 'top-right' | 'bottom-right' | 'bottom-left';
  port?: string;
}
const slots = useSlots();
const toastList = ref<IToast[]>([] as IToast[]);

const addToast = (e: any) => {
  const toast = Object.assign({}, e.detail);
  toast.key = (Math.random() + 1).toString(36).substring(5);
  toastList.value.push(toast);
};

const removeToast = (key?:string) => {
  toastList.value = toastList.value.filter(el => key !== el.key);
};

catchEvent('pushToast', addToast);
onBeforeUnmount(() => {
  catchEvent('pushToast', addToast, true);
});
</script>

<style lang="scss" scoped src="./styles/toast-container.scss" />
